import { EVENTS } from 'n2p-ui-library/constants'
import i18n from 'i18n'
// module imports
import { isPhoneNumber } from 'modules/PhoneNumbers'
// constant imports
import { DISPATCH_EVENTS } from 'constants/GlobalEvents'
import { eventDispatch } from './Events'

/**
 * Send block number event
 *
 * @param {string} phoneNumber
 */
export const blockNumber = (phoneNumber) => {
  // if phone is restricted
  if (!isPhoneNumber(phoneNumber)) return

  eventDispatch(DISPATCH_EVENTS.BLOCK_NUMBER, { phoneNumber })
}

export const toggleMergeExpanded = (expanded) => {
  eventDispatch(DISPATCH_EVENTS.CONFIG.TOGGLE_MERGE_EXPANDED, { expanded })
}

export const dialerIsConnected = (connected) => {
  eventDispatch(DISPATCH_EVENTS.DIALER_IS_CONNECTED, { connected })
}

export const outgoingCallConnected = () => {
  eventDispatch(DISPATCH_EVENTS.SESSION.OUTGOING)
}

const showSnackbar = (
  event,
  originalText,
  icon = undefined,
  needToTranslate = true,
) => {
  const text = needToTranslate ? i18n.t(originalText) : originalText

  eventDispatch(event, { text, icon })
}

export const showSuccessSnackbar = (
  originalText,
  icon = undefined,
  needToTranslate = true,
) => {
  showSnackbar(
    EVENTS.SHOW_SUCCESS_SNACKBAR,
    originalText,
    icon,
    needToTranslate,
  )
}

export const showErrorSnackbar = (
  originalText,
  icon = undefined,
  needToTranslate = true,
) => {
  showSnackbar(EVENTS.SHOW_ERROR_SNACKBAR, originalText, icon, needToTranslate)
}
